<template>
  <div>
    <h4 class="primary--text font-weight-medium">
      {{ $t('buttons:upload-specific', { specific: $t('common:media')}) }}
    </h4>

    <ImageViewer
      v-show="mediaType === 'IMAGE'"
      maxHeight="250"
      maxWidth="250"
      :hideOverlay="true"
      ref="imageViewer"
    />
    <v-img
      v-show="mediaType === 'PDF'"
      src="@/assets/preview_pdf16x9.png"
      max-height="250"
      max-width="250"
    />
    <video
      ref="videoContainer"
      v-if="mediaType === 'VIDEO' && videoLink.videoLoaded"
      controls
      @loadedmetadata="updateMediaLength"
      class="photo-preview-media">
        <source
          :src="videoLink.src"/>Your browser does not support the video tag.
    </video>

    <v-file-input
      ref="uploadedFile"
      accept="image/*, application/pdf, video/*"
      :label="$t('buttons:upload-specific', { specific: $t('common:media')})"
      show-size
      v-model="file"
      :rules="[ruleMaxFileSize(200000, $t('utils:rules.filesize', {size : '200 MB'}))]"
      @change="uploadMedia"
    >
      <template v-slot:append>
        <v-fade-transition leave-absolute>
          <v-progress-circular
              v-show="isMediaLoading"
              size="24"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-fade-transition>
      </template>
    </v-file-input>
  </div>
</template>

<script>
import ImageViewer from '@/modules/core/components/DocumentViewer/ImageViewer';
import AdvertService from '@/modules/display/services/advert-service';
import {ruleMaxFileSize} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'MediaContainer',
  components: {
    ImageViewer
  },
  props: {
    advertId: String,
    mediaFile: Object
  },
  data() {
    return {
      mediaType: '',
      file: null,
      media: {},
      newVideoUploaded: false,
      isMediaLoading: false,
      videoLink: {
        src: ''
      }
    }
  },
  watch: {
    mediaFile: {
      deep: true,
      handler() {
        this.reset();
        if (!this.mediaFile || !this.mediaFile.name) return;
        this.setMediaType(this.mediaFile.type);
        this.media = Object.assign({}, this.mediaFile);
        this.showMedia(this.mediaFile);
      }
    }
  },
  methods: {
    ruleMaxFileSize,
    setMediaType(type) {
      this.mediaType = type !== null ? type : '';
      if (typeof type === 'undefined') {
        this.$emit('updateType', 'UNDEFINED');
        return;
      }

      type = type.toLocaleLowerCase();
      if (type.indexOf('image') !== -1) {
        this.mediaType = 'IMAGE';
      } else if(type.indexOf('video') !== -1) {
        this.mediaType = 'VIDEO';
      } else if (type.indexOf('pdf') !== -1) {
        this.mediaType = 'PDF';
      }

      this.$emit('updateType', this.mediaType);
    },
    reset() {
      this.media = {};
      this.setMediaType();
      this.$refs.imageViewer.reset();
    },
    uploadMedia() {
      if(!this.file) return;
      this.setMediaType();
      this.$refs.imageViewer.reset();
      this.isMediaLoading = true;

      AdvertService.uploadMedia(
        this.file,
        (response) => {
          this.isMediaLoading = false;
          this.setMediaType(this.file.type);
          this.media.type = this.file.type;
          this.media.name = this.file.name;

          if (this.mediaType === 'VIDEO') {
            this.newVideoUploaded = true;
          }

          this.showMedia({name: this.file.name, id: response.data.id, type: this.file.type});
          this.$emit('newMedia', response.data);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:upload-failure', {name: this.$t('display/advert:edit.snackbar.picture')}));
        }
      )
    },
    showMedia(mediaFile) {
      let media = {
        name: mediaFile.name,
        src: '',
        videoLoaded: false
      };
      AdvertService.getFileAsDataUrl(
        mediaFile.id,
        this.mediaType === 'VIDEO',
        (result) => {
          media.src = result
          media.videoLoaded = true;
        }
      );

      if (this.mediaType === 'IMAGE') {
        this.$refs.imageViewer.initViewer(media);
      } else if (this.mediaType === 'VIDEO') {
        this.videoLink = media;
      }
    },
    updateMediaLength() {
      if (this.newVideoUploaded) {
        this.$emit('updateVideoLength', Math.floor(this.$refs.videoContainer.duration));
        this.newVideoUploaded = false;
      }
    }
  }
}
</script>

<style scoped>
.photo-preview-media {
  max-height: 250px;
  max-width: 250px;
}

.photo-preview-container {
  width: 500px;
  height: 560px;
}

.photo-container .v-image__image {
  width: 374px;
  height: 210px;
  position: absolute;
  top: 69px;
  left: 78px;
}

.photo-preview-display {
  position: absolute;
  top: 69px;
  left: 78px;
  width: 374px;
  height: 210px;
}
</style>